<div class="user-dashboard-page" aria-label="Usage Analytics dashboard">
	<section class="dashboard-shell">
		<div class="dashboard-header">
			<div class="dashboard-header__copy">
				<p class="dashboard-header__eyebrow">Analytics</p>
				<h1>Usage Dashboard</h1>
				<p class="dashboard-header__subtitle">
					Connected to the usage analytics API to track adoption.
				</p>
			</div>

			<form class="dashboard-filters" (ngSubmit)="onApplyFilters()">
				<div class="dashboard-filters__meta-row" *ngIf="lastModifiedDisplay">
					<button
						type="button"
						class="dashboard-filters__consolidated-btn"
						*ngIf="canShowConsolidatedReportButton"
						(click)="openConsolidatedReport()">
						Consolidated Report
					</button>

					<p class="dashboard-filters__meta">
						Last updated: {{ lastModifiedDisplay }}
					</p>
				</div>

				<label class="dashboard-filters__field">
					<span>From</span>
					<input
						type="date"
						name="startDate"
						[(ngModel)]="filters.startDate"
						aria-label="Usage analytics start date"
					/>
				</label>

				<label class="dashboard-filters__field">
					<span>To</span>
					<input
						type="date"
						name="endDate"
						[(ngModel)]="filters.endDate"
						aria-label="Usage analytics end date"
					/>
				</label>

				<button type="submit" [disabled]="isLoading">
					{{ isLoading ? 'Loading…' : 'Apply' }}
				</button>
			</form>
		</div>

		<div class="dashboard-banner dashboard-banner--error" *ngIf="errorMessage">
			<span class="material-icons-outlined">error</span>
			<p>{{ errorMessage }}</p>
		</div>

		<div class="dashboard-banner" *ngIf="!errorMessage && !isLoading && !hasMatchedActivity">
			<span class="material-icons-outlined">info</span>
			<p>No usage activity was found for the selected date range.</p>
		</div>

		<div class="dashboard-loading" *ngIf="isLoading">
			<mat-spinner diameter="36"></mat-spinner>
			<p>Loading usage analytics…</p>
		</div>

		<section class="dashboard-kpis" *ngIf="!isLoading">
			<article
				*ngFor="let card of dashboardVm.kpis; trackBy: trackKpiCard"
				class="kpi-card"
				[class.kpi-card--clickable]="card.clickAction"
				(click)="onKpiCardClick(card)"
				[attr.role]="card.clickAction ? 'button' : null"
				[attr.tabindex]="card.clickAction ? '0' : null"
			>
				<p class="kpi-card__label">{{ card.label }}</p>
				<h2 class="kpi-card__value">{{ card.value }}</h2>
				<p class="kpi-card__subtext">{{ card.subtext }}</p>
				<p class="kpi-card__helper" *ngIf="card.helper">{{ card.helper }}</p>
			</article>

			<article class="kpi-card kpi-card--sentiment" aria-label="Feedback sentiment summary">
				<p class="kpi-card__label">Feedback Sentiment</p>
				<div class="sentiment-grid">
					<div class="sentiment-chip sentiment-chip--likes">
						<p class="sentiment-chip__label">Likes</p>
						<p class="sentiment-chip__value">{{ dashboardVm.feedbackSentiment.likes }}</p>
					</div>
					<div class="sentiment-chip sentiment-chip--dislikes">
						<p class="sentiment-chip__label">Dislikes</p>
						<p class="sentiment-chip__value">{{ dashboardVm.feedbackSentiment.dislikes }}</p>
					</div>
				</div>
			</article>
		</section>

		<section class="dashboard-grid" *ngIf="!isLoading">
			<article class="dashboard-panel">
				<div class="dashboard-panel__header">
					<div>
						<h3>Daily Active Users</h3>
						<p>User activity trend across the selected period.</p>
					</div>
				</div>

				<div class="dashboard-panel__body" *ngIf="hasDailyActiveUsersData; else noDailyUsersData">
					<div
						echarts
						class="chart-host"
						[options]="dailyActiveUsersChartOptions"
						[initOpts]="chartInitOptions"
					></div>
				</div>
			</article>

			<article class="dashboard-panel">
				<div class="dashboard-panel__header">
					<div>
						<h3>Agent Usage Distribution</h3>
						<p>How questions were distributed across the available agents.</p>
					</div>
				</div>

				<div class="dashboard-panel__body" *ngIf="hasAgentUsageData; else noAgentUsageData">
					<div
						echarts
						class="chart-host"
						[options]="agentUsageChartOptions"
						[initOpts]="chartInitOptions"
					></div>
				</div>
			</article>
		</section>
	</section>
</div>

<ng-template #noDailyUsersData>
	<div class="dashboard-empty-state">
		<span class="material-icons-outlined">show_chart</span>
		<p>No daily active user data is available for this selection.</p>
	</div>
</ng-template>

<ng-template #noAgentUsageData>
	<div class="dashboard-empty-state">
		<span class="material-icons-outlined">stacked_bar_chart</span>
		<p>No agent usage distribution is available for this selection.</p>
	</div>
</ng-template>
